import script from "./esCalendarHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./esCalendarHeader.vue?vue&type=script&setup=true&lang=ts"

import "./esCalendarHeader.vue?vue&type=style&index=0&id=bd10d1a2&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd10d1a2"]])

export default __exports__